import { fetchNaniClub } from "@/apis/naniclub/base";
import type { GetProfileResponse } from "@/types/apis/naniclub";

export const getProfile = (): Promise<GetProfileResponse> =>
  fetchNaniClub<GetProfileResponse>({
    url: "/users/profile",
    method: "GET",
  });
